import { React, useEffect, useState } from "react";
import { Box, Typography } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import AccountBoxOutlinedIcon from "@material-ui/icons/AccountBoxOutlined";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import NotificationsIcon from "@material-ui/icons/Notifications";
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";
import { MobileRegularPage } from "../../../components";
import MobileLoading from "../../../components/MobileLoading";
import { AppButton } from "../components/InputComponents";
import { localStorageCleanup } from "../../../services/util.service";
import useStyles from "./Dashboard.style";
import IconChart from "../../../images/icon_chart.png";
import IconProfile from "../../../images/icon_profile.png";
import IconMyRepli from "../../../images/icon_myrepli.png";
import IconMyResources from "../../../images/icon_myresources.png";
import HomeBariatricsIcon from '../../../images/HomeBariatricsIcon.png'
import DashboardButton from "./DashboardButton";
import Cookies from "universal-cookie";
import PatientInterests from "../../PatientInterests";
import { interestItems } from "../../../data/db";
import CheckIn from "../../CheckIn";
const cookies = new Cookies();
const Dashboard = (props) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [healthProfile, setHealthProfile] = useState("");
  const [feedbackNotification, setFeedbackNotification] = useState(false);
  const [notificationCount, setNotificationCount] = useState("");
  const [patientInterestsPage, setPatientInterestsPage] = useState();
  const [initialInterestsData, setInitialInterestsData] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [userId, setUserId] = useState();
  const [showcheckInPage, setShowcheckInPage] = useState(true);
  const [interestLength, setInterestLength] = useState(0);
  const [isFirstTimeLogin, setIsFirstTimeLogin] = useState(false);

  const handleSwitchToRegularPage = () => {
    const currentTime = new Date().getTime();
    localStorage.setItem('lastShownTime', currentTime);
    setShowcheckInPage(false);

  };
  useEffect(() => {
    setInitialInterestsData(interestItems);

    const getHealthProfile = async () => {
      try {
        let response = await fetch(
          `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PATIENT_PROFILE}`,
          {
            headers: {
              "X-ACCESS-TOKEN": cookies.get("token"),
            },
          }
        );
        if (!response) return;
        let json = await response.json();
        setHealthProfile(json);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    const getMyFeedBack = async () => {
      try {
        let response = await fetch(
          `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PATIENT_FEEDBACK}`,
          {
            headers: {
              "X-ACCESS-TOKEN": cookies.get("token"),
            },
          }
        );
        if (!response.ok) {
          setFeedbackNotification(true);
        } else {
          setFeedbackNotification(false);
        }
      } catch (error) {
        setFeedbackNotification(true);
        console.log(error);
      }
    };

    const getNotifications = async () => {
      try {
        let response = await fetch(
          `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_NOTIFICATION}`,
          {
            headers: {
              "X-ACCESS-TOKEN": cookies.get("token"),
            },
          }
        );
        if (!response) return;
        let notifications = await response.json();
        setNotificationCount(notifications.length);
      } catch (error) {
        console.log(error);
      }
    };

    const getUserId = async () => {
      setLoading(true);

      await fetch(
        `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_AUTH}/app/me`,
        {
          headers: {
            "X-ACCESS-TOKEN": cookies.get("token"),
          },
        }
      )
        .then((res) => res.json())
        .then((res) => {
          setUserId(res._id);
          setLoading(true);
          let url = new URL(
            `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_USER_INTERESTS}`
          );
          url.searchParams.append("id", res._id);
          fetch(url, {
            headers: {
              "X-ACCESS-TOKEN": cookies.get("token"),
            },
          })
            .then((res) => res.json())
            .then((res) => {
              setInterestLength(res.length)
              setLoading(false);
              if (res.length > 0) {
                setPatientInterestsPage(false);
                if (localStorage.getItem('isFirstTimeLogin'))
                  setIsFirstTimeLogin(true);
                else
                  setIsFirstTimeLogin(false);
              }
              else {
                setPatientInterestsPage(true);
                setIsFirstTimeLogin(true);
                localStorage.setItem('isFirstTimeLogin', true);
              }
            })
            .catch((error) => {
              console.log(error);
              setLoading(false);
            });
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error fetching user ID:", error);
        });
    };

    getUserId();
    getHealthProfile();
    getMyFeedBack();
    getNotifications();


  }, []);


  useEffect(() => {
    const getCheckIn = async () => {
      try {
        let url = new URL(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_USER_GET_CHECKIN}`)

        url.searchParams.append("id", userId);
        let response = await fetch(
          url,
          {
            headers: {
              "X-ACCESS-TOKEN": cookies.get("token"),
            },

          }  
        );
        if (!response) return;

        let json = await response.json();
        const letCheckInExists = json && json.some(item => (new Date(item.updatedAt).getTime() >= (new Date().getTime() - 24 * 60 * 60 * 1000)));
        setShowcheckInPage(!letCheckInExists);

      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    getCheckIn()

  }, [userId])


  const handleOnClickItems = (i) => {
    if (initialInterestsData[i].id === i) {
      setSelectedIndex([...selectedIndex, i]);
      setSelectedItems([...selectedItems, initialInterestsData[i].item]);
      if (selectedIndex.includes(i)) {
        let filteredSelectedIndex = selectedIndex.filter((val) => {
          return val !== i;
        });
        setSelectedIndex([...filteredSelectedIndex]);
      } else {
        setSelectedIndex([...selectedIndex, i]);
      }
      if (selectedItems.includes(initialInterestsData[i].item)) {
        let filteredSelectedItems = selectedItems.filter((val) => {
          return val !== initialInterestsData[i].item;
        });
        setSelectedItems([...filteredSelectedItems]);
      } else {
        setSelectedItems([...selectedItems, initialInterestsData[i].item]);
      }
    }
  };

  const handleSignOut = async (e) => {
    try {
      await fetch(
        `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_AUTH_SIGNOUT}`
      );
      localStorageCleanup();
      localStorage.setItem("logout-event", "logout" + Math.random());
      cookies.remove("token", { path: "/" });
      props.history.push("/app");
    } catch (error) {
      console.log(error);
    }
  };

  const handleGoToDashboard = async () => {
    setLoading(true);
    try {
      let response = await fetch(
        `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_USER_ADD_INTERESTS}`,
        {
          method: "post",
          body: new URLSearchParams({
            id: userId,
            interests: selectedItems,
          }),
          headers: {
            "X-ACCESS-TOKEN": cookies.get("token"),
          },
        }
      );
      if (!response) return;
      else {
        setLoading(false);
        setPatientInterestsPage(false);
        return;
      }
    } catch (error) {
      setPatientInterestsPage(true);
      setLoading(false);
      console.log(error);
    }
  };
  useEffect(() => {
    scrollToTop();
  }, [])
  const scrollToTop = () => {
    window.scrollTo(0, 0)
  }


  if (loading) return <MobileLoading />;


  else if (patientInterestsPage) return (

    <PatientInterests
      selectedIndex={selectedIndex}
      initialInterestsData={initialInterestsData}
      selectedItems={selectedItems}
      handleOnClick={handleOnClickItems}
      handleGoToDashboard={handleGoToDashboard}
    />);



  else if (patientInterestsPage === false) return (
    <>
      {
        (showcheckInPage && interestLength > 0 && isFirstTimeLogin == false) ? <CheckIn handleRegularPageClick={handleSwitchToRegularPage} /> :
          <MobileRegularPage>
            <Typography variant="h3" className={classes.title}>
              Welcome back, {healthProfile.firstName}
            </Typography>
            <Box className={classes.buttonContainer}>
              <Box className={classes.buttonRow}>
                <DashboardButton
                  iconComponent={
                    <img
                      className={classes.buttonIcon}
                      src={IconChart}
                      alt="MyQuotient Icon"
                    />
                  }
                  iconAlt="My Goal Icon"
                  linkPath="/app/mygoal"
                  label="My Goal"
                  pending={healthProfile.desiredChildrenQty === undefined}
                  scrollToTop={scrollToTop}
                />
                <DashboardButton
                  iconComponent={
                    <img
                      className={classes.buttonIcon}
                      src={IconMyRepli}
                      alt="MyRepli Icon"
                    />
                  }
                  iconAlt="MyRepli Icon"
                  linkPath="/app/myrepli"
                  label="My Repli"

                />
                 <DashboardButton
                  iconComponent={
                    <img
                      className={classes.buttonIcon}
                      src={IconProfile}
                      alt="MyProfile Icon"
                    />
                  }
                  iconAlt="MyProfile Icon"
                  linkPath="/app/profiler"
                  label="My Profile"
                  pending={healthProfile.dateOfBirth === undefined}
                />
              </Box>
              <Box className={classes.buttonRow}>
                <DashboardButton
                  iconComponent={
                    <FamilyRestroomIcon
                      className={classes.buttonIcon}
                      color="primary !important"
                      style={{ width: "45px", height: "45px" }}
                    />
                  }
                  iconAlt="family history"
                  linkPath="/app/familyhistory"
                  label="Family History"
                  scrollToTop={scrollToTop}
                  pending={
                    healthProfile.fhGeneral === undefined ||
                    healthProfile.fhGeneral?.length === 0 ||
                    healthProfile.fhBehavioral === undefined ||
                    healthProfile.fhBehavioral?.length === 0 ||
                    healthProfile.fhCardiovascular === undefined ||
                    healthProfile.fhCardiovascular?.length === 0 ||
                    healthProfile.fhEndocrine === undefined ||
                    healthProfile.fhEndocrine?.length === 0 ||
                    healthProfile.fhGastrointestinal === undefined ||
                    healthProfile.fhGastrointestinal?.length === 0 ||
                    healthProfile.fhHematologic === undefined ||
                    healthProfile.fhHematologic?.length === 0 ||
                    healthProfile.fhImmunologic === undefined ||
                    healthProfile.fhImmunologic?.length === 0 ||
                    healthProfile.fhNeurologic === undefined ||
                    healthProfile.fhNeurologic?.length === 0 ||
                    healthProfile.fhOncologic === undefined ||
                    healthProfile.fhOncologic?.length === 0 ||
                    healthProfile.fhPsychiatric === undefined ||
                    healthProfile.fhPsychiatric?.length === 0 ||
                    healthProfile.fhRespiratory === undefined ||
                    healthProfile.fhRespiratory?.length === 0 ||
                    healthProfile.fhRespiratory === undefined ||
                    healthProfile.fhReproductive?.length === 0
                  }
                />
                <DashboardButton
                  iconComponent={
                    <img
                      className={classes.buttonIcon}
                      src={IconMyResources}
                      alt="MyResources Icon"
                    />
                  }
                  iconAlt="MyResources Icon"
                  linkPath={{ pathname: "https://www.repli.online" }}
                  label="My Resources"
                  target="_blank"
                />

                <DashboardButton
                  iconComponent={
                    <AccountBoxOutlinedIcon
                      className={classes.buttonIcon}
                      color="primary"
                    />
                  }
                  linkPath="/app/myaccount"
                  label="My Account"
                  scrollToTop={scrollToTop}
                />
              </Box>
              <Box className={classes.buttonRow}>
                <DashboardButton
                  iconComponent={
                    <QuestionAnswerIcon
                      className={classes.buttonIcon}
                      color="primary"
                    />
                  }
                  iconAlt="Survey Icon"
                  linkPath={
                    feedbackNotification === true
                      ? "/app/feedback"
                      : "/app/feedbacksubmitted"
                  }
                  label="Share your feedback!"
                  pending={feedbackNotification}
                  scrollToTop={scrollToTop}
                />
                <DashboardButton
                  iconComponent={
                    <NotificationsIcon
                      className={classes.buttonIcon}
                      color="primary"
                    />
                  }
                  linkPath="/app/notification"
                  label="Notification"
                  isNotification="true"
                  notificationCount={notificationCount}
                  scrollToTop={scrollToTop}
                />
                 <DashboardButton
                  iconComponent={
                     <img
                    className={classes.buttonIcon}
                    src={HomeBariatricsIcon}
                    alt="Bariatrics Icon"
                  />}
                  iconAlt="Survey Icon"
                  linkPath='/app/bariatrics'
                  label="Bariatrics"
                  pending={healthProfile.hereForBariatricCare ===  '' || 
                    healthProfile.hereForBariatricCare === undefined
                  }
                  scrollToTop={scrollToTop}
                />
              </Box>
             
            </Box>
            <Box className={classes.footer}>
              <AppButton
                className={classes.footerButton}
                variant="contained"
                color="secondary"
                fullWidth
                size="large"
                onClick={handleSignOut}
              >
                Sign Out
              </AppButton>
            </Box>
          </MobileRegularPage>
      }
    </>

  )

  return (<MobileLoading />);
};

export default withRouter(Dashboard);